// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__3lV6A","title":"AfterImages45_title__AWcG_","images":"AfterImages45_images__1LT-Q"};